module.exports = __webpack_public_path__ + "img/gigamon.d89acd96.webp";